import React, { useEffect } from "react";
import { useFetch, useResource, useForm, useGrid, useModal, usePage, useTheme, useTree } from "@/comn/hooks";
import { Button, Grid, Group, Layout, Page, Tree } from "@/comn/components";
import { APIS, SF_CSTMSROLE_SRCH, SG_CSTM_ROLE_LIST } from "./services/PtliCstmRoleService";
import { comnUtils } from "@/comn/utils";
import { PTLI1006002Q } from "@/tra/tancis/ptli/ptl/cstmrole/PTLI1006002Q";
import { useTranslation } from "react-i18next";

/*
 * Linking Customs Roles
 * !== 세관 역할 연결 화면 ==!
 */
export const PTLI1006001S = (): JSX.Element => {
    useResource({
        defaultSchema: [{ area: "cstmOrgzCd" }],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const modal = useModal();
    const tree = useTree();
    const { theme } = useTheme();
    const { t } = useTranslation();

    const form = { cstmRoleSrch: useForm({ defaultSchema: SF_CSTMSROLE_SRCH }) };
    const grid = { cstmRoleList: useGrid({ defaultSchema: SG_CSTM_ROLE_LIST }) };

    const fetch = {
        getCstmData: useFetch({
            api: () => APIS.getCstmData(form.cstmRoleSrch.getValues()),
            onSuccess: (data: any) => {
                const cstmList = data["cstmList"].content;
                tree.setData([
                    {
                        name: "Section Organization",
                        children: handler.createTreeData(cstmList, [], 1, "ORGZ000000"),
                    },
                ]);

                tree.openTree();
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        getCstmRoleList: useFetch({
            api: () => APIS.getCstmRoleList(form.cstmRoleSrch.getValues()),
            onSuccess: () => {},
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        getSctnList: useFetch({
            api: () => APIS.getSctnList(),
            onSuccess: (data: any) => {
                const { content } = data.sctnList;
                form.cstmRoleSrch.setSchema("cstmSctnCd", { options: content });
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        saveCstmRole: useFetch({
            api: () =>
                APIS.saveCstmRole({
                    cstmOrgzId: form.cstmRoleSrch.getValue("cstmOrgzId"),
                    cstmRoleList: grid.cstmRoleList.getData(),
                }),
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00062" }); // 정상적으로 저장되었습니다.
                fetch.getCstmRoleList.fetch();
            },
            onError: () => modal.openModal({ content: "msg.com.00026" }), // Failed to save. !==  저장이 실패하였습니다. ==!
        }),
    };
    const handler = {
        onSrchClick: form.cstmRoleSrch.handleSubmit(() => fetch.getCstmData.fetch()),
        onSaveClick: () => {
            const list = grid.cstmRoleList.getData({ excludes: ["origin"] });
            if (list.length === 0) {
                modal.openModal({ content: "msg.ptl.00741" }); // There is no data to be stored and deleted. !== 저장 및 삭제 대상 데이터가 없습니다. ==!
                return;
            }

            modal.openModal({
                content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                onConfirm: () => fetch.saveCstmRole.fetch(),
            });
        },
        onGridAddClick: () => {
            if (comnUtils.isEmpty(form.cstmRoleSrch.getValue("cstmOrgzId"))) {
                modal.openModal({ content: "msg.com.00086" }); // No data has been selected.. !== 선택된 데이터가 없습니다. ==!
                return;
            }

            const modalCallback = (list: any[]) => {
                const cstmRolelist = grid.cstmRoleList.getData();
                list.forEach(
                    (item: any) =>
                        cstmRolelist.findIndex((subItem: any) => item.roleId === subItem.roleId) === -1 &&
                        grid.cstmRoleList.addRow(item),
                );
                modal.closeModal();
            };

            modal.openModal({
                draggable: true,
                size: "sm",
                content: (
                    <PTLI1006002Q
                        condData={form.cstmRoleSrch.getValues()}
                        cstmRoleList={grid.cstmRoleList.getData()}
                        callback={modalCallback}
                    />
                ),
            });
        },
        onGridDelClick: () => {
            if (comnUtils.isEmpty(form.cstmRoleSrch.getValue("cstmOrgzId"))) {
                modal.openModal({ content: "msg.com.00086" }); // No data has been selected.. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            modal.openModal({
                content: "msg.com.00049",
                onConfirm: () => {
                    grid.cstmRoleList.deleteRow("checkbox");
                },
            });  
        },
        onTreeClick: (treeInfo: any) => {
            const { nodeData } = treeInfo;
            // if( comnUtils.isEmpty(nodeData) || nodeData.cstmOrgzTpCd !== "U") {
            //     form.cstmRoleSrch.setValue("cstmOrgzId"  , null);
            //     form.cstmRoleSrch.setValue("cstmOrgzPath", t("msg.com.00038", { 0: "Unit"}));
            //     if(grid.cstmRoleList.getData().length > 0)  grid.cstmRoleList.clearData();
            //
            //     modal.openModal({content: "msg.ptl.00738"}) // Only Unit can be selected. !== Unit 만 선택 할 수 있습니다. ==!
            //     return;
            // }

            if (comnUtils.isUndefined(nodeData?.cstmOrgzId)) {
                form.cstmRoleSrch.setValue("cstmOrgzPath", t("msg.com.00038", { 0: "Unit" }));
            } else {
                form.cstmRoleSrch.setValue("cstmOrgzId", nodeData.cstmOrgzId);
                form.cstmRoleSrch.setValue("cstmOrgzPath", nodeData.cstmOrgzPath);
                fetch.getCstmRoleList.fetch();
            }
        },
        createTreeData: (orgList: any, newList: any, level: any, cstmOrgzId: any) => {
            const tempList = orgList
                .filter((item: any) => item["dpthLvl"] === level && item["uprCstmOrgzId"] === cstmOrgzId)
                .map((item: any) => {
                    return {
                        name: comnUtils.replaceEmpty(item.cstmOrgzNm),
                        children: [],
                        nodeData: item,
                    };
                });

            if (tempList.length > 0) {
                tempList.forEach((item: any) => {
                    const { nodeData } = item;
                    handler.createTreeData(orgList, item.children, nodeData.dpthLvl + 1, nodeData.cstmOrgzId);
                    newList.push(item);
                });
            }
            return newList;
        },
        onClear: () => {
            form.cstmRoleSrch.clearValues();
            grid.cstmRoleList.clearData();

            tree.setData([
                {
                    name: "Section Organization",
                    children: [],
                },
            ]);
        },
    };

    useEffect(() => {
        form.cstmRoleSrch.setValue("cstmOrgzPath", t("msg.com.00038", { 0: "Unit" }));
        fetch.getSctnList.fetch();

        !comnUtils.isEmpty(form.cstmRoleSrch.getValue("cstmSctnCd")) && fetch.getCstmData.fetch();
    }, [theme]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.cstmRoleSrch.schema.cstmSctnCd}
                                popupParams={{ cstmOrgzTpCd: "S" }}
                            />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={handler.onClear} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Cell gap={4}>
                        <Group>
                            <Group.Header>
                                <Group.Title title={"T_SCTN_ORGZ"} />
                            </Group.Header>
                            <Tree defaultOpen={true} {...tree.tree} height={500} onClick={handler.onTreeClick} />
                        </Group>

                        <Group.Section gap={4}>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.cstmRoleSrch.schema.cstmOrgzPath} />
                                </Group.Row>
                            </Group.Section>
                            <Group.Section gap={2}>
                                <Layout.Right>
                                    <Button role={"gridAdd"} onClick={handler.onGridAddClick} />
                                    <Button role={"gridDelete"} onClick={handler.onGridDelClick} />
                                </Layout.Right>
                                <Grid {...grid.cstmRoleList.grid} data={fetch.getCstmRoleList.data?.cstmRoleList} />
                                <Layout.Right>
                                    {" "}
                                    <Button role={"save"} onClick={handler.onSaveClick} />{" "}
                                </Layout.Right>
                            </Group.Section>
                        </Group.Section>
                    </Group.Cell>
                </Group.Body>
            </Group>
        </Page>
    );
};
